import React, { useState } from 'react';
import { Container, Card, Button, Alert, Dropdown, Badge } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const QRSimulation = () => {
  // Stările posibile: "stolen" (roșu), "neutral" (gri), "normal" (verde)
  const [itemStatus, setItemStatus] = useState('normal');
  
  // Datele produsului în funcție de stare
  const statusData = {
    stolen: {
      color: 'danger',
      title: 'Laptop MacBook Pro',
      message: 'ATENȚIE! Acest obiect a fost declarat FURAT! Vă rugăm să contactați autoritățile.',
      contact: 'john.doe@example.com',
      badgeText: 'FURAT',
      headerClass: 'bg-danger text-white'
    },
    neutral: {
      color: 'secondary',
      title: 'Laptop MacBook Pro',
      message: '',
      contact: '',
      badgeText: 'NEUTRU',
      headerClass: 'bg-secondary text-white'
    },
    normal: {
      color: 'success',
      title: 'Laptop MacBook Pro',
      message: 'Acest laptop aparține lui John Doe. Dacă l-ați găsit, vă rog să mă contactați. Ofer recompensă!',
      contact: 'john.doe@example.com',
      badgeText: 'NORMAL',
      headerClass: 'bg-success text-white'
    }
  };

  // Obține datele curente în funcție de stare
  const currentData = statusData[itemStatus];

  return (
    <div className="simulation-page">
      <div className="d-flex justify-content-end p-3">
        <Dropdown>
          <Dropdown.Toggle variant="outline-primary" id="dropdown-status">
            Schimbă Starea
          </Dropdown.Toggle>
          <Dropdown.Menu>
            <Dropdown.Item onClick={() => setItemStatus('normal')}>Normal (Verde)</Dropdown.Item>
            <Dropdown.Item onClick={() => setItemStatus('neutral')}>Neutru (Gri)</Dropdown.Item>
            <Dropdown.Item onClick={() => setItemStatus('stolen')}>Furat (Roșu)</Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </div>

      <Card className="mx-auto shadow" style={{ maxWidth: '600px' }}>
        <Card.Header className={currentData.headerClass}>
          <div className="d-flex justify-content-between align-items-center">
            <h5 className="mb-0">Informații Obiect</h5>
            <Badge bg={currentData.color}>{currentData.badgeText}</Badge>
          </div>
        </Card.Header>
        <Card.Body className="text-center">
          <div className="display-1 mb-4">
            {itemStatus === 'stolen' ? '🚨' : itemStatus === 'neutral' ? '❓' : '✅'}
          </div>
          <Card.Title className="display-6">{currentData.title}</Card.Title>
          
          <hr />
          
          <div className="my-4">
            {itemStatus === 'neutral' ? (
              <Alert variant="secondary">
                Utilizatorul nu a publicat niciun mesaj pentru acest produs. 
                Statutul este neutru, nu se știe dacă obiectul a fost furat sau dacă există vreo problemă cu el.
              </Alert>
            ) : (
              <>
                <h5 className="mt-4">Mesaj de la proprietar</h5>
                <p className={itemStatus === 'stolen' ? 'text-danger fw-bold' : ''}>{currentData.message}</p>
                
                {currentData.contact && (
                  <>
                    <h5 className="mt-4">Informații de contact</h5>
                    <p>{currentData.contact}</p>
                    
                    <Button 
                      variant={currentData.color} 
                      href={`mailto:${currentData.contact}`}
                      className="mt-2"
                    >
                      {itemStatus === 'stolen' ? 'Contactează Autoritățile' : 'Contactează Proprietarul'}
                    </Button>
                  </>
                )}
              </>
            )}
          </div>
          
          <div className="mt-5">
            <p className="text-muted small">
              Acest obiect este protejat de Serviciul de Securitate QR.
            </p>
            <Link to="/" className="btn btn-link">Află mai multe despre Securitatea QR</Link>
          </div>
        </Card.Body>
      </Card>
    </div>
  );
};

export default QRSimulation;